import Service from "./Service";
const baseurl = '/api/convenciones-odontograma';
export default {
    index() {
        return Service.get(`${baseurl}`);
    }
}